import React from 'react';
var NotFound = function () { return (React.createElement("div", null, "404")); };
export default NotFound;
